import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, getProductDetails, newReview } from '../../redux/actions/productAction';
import { addToCart } from '../../redux/actions/cartActions';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import Loader from '../common/Loader';
import { toast } from 'react-hot-toast';
import { Col, Container, Row, Form, FloatingLabel } from 'react-bootstrap';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button } from '@mui/material';
import Rating from '@mui/material/Rating';
import ReviewCard from './ReviewCard';
import { BsEmojiSmile } from 'react-icons/bs';
import MetaData from '../MetaData';
import { NEW_REVIEW_RESET } from '../../redux/constants/productConstants';

const ProductDetails = () => {
    const dispatch = useDispatch();
    const { product, loading, error } = useSelector((state) => state.productDetails);
    const { success, error: reviewError } = useSelector((state) => state.newReview);
    const [quantity, setQuantity] = useState(1);
    const [openReviewModal, setOpenReviewModal] = useState(false);
    const [comment, setComment] = useState('');
    const [rating, setRating] = useState(0);

    const id = useParams().id;
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (reviewError) {
            toast.error(reviewError);
            dispatch(clearErrors());
        }
        if (success) {
            toast.success('Review Submitted successfully!');
            dispatch({ type: NEW_REVIEW_RESET });
        }
        dispatch(getProductDetails(id));
    }, [dispatch, id, error, success, reviewError]);

    const submitAddToCart = () => {
        dispatch(addToCart(id, quantity));
        toast.success('Item added to Cart');
    };

    const handleQuantity = (type) => {
        if (type === 'INCREMENT') {
            if (product.Stock <= quantity) {
                return;
            }
            setQuantity(quantity + 1);
        } else if (type === 'DECREMENT') {
            if (quantity <= 1) {
                return;
            }
            setQuantity(quantity - 1);
        }
    };

    const handleToggleReviewModal = () => setOpenReviewModal(!openReviewModal);

    const handleSubmitRating = (e) => {
        e.preventDefault();
        const formObj = {
            rating,
            comment,
            productId: id,
        };
        dispatch(newReview(formObj));
        setOpenReviewModal(false);
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`${product?.name} - ShipShop`} />
            <Container>
                <div className='section-padding-top section-padding-bottom'>
                    {product && (
                        <div className='productDetails'>
                            <Row className='mb-5'>
                                <Col md={5}>
                                    <Slider className='productDetailsSticky' {...settings}>
                                        {product.images.map((image, i) => (
                                            <img key={i} src={image.url} alt='' />
                                        ))}
                                    </Slider>
                                </Col>
                                <Col md={7} className='py-4 ps-sm-5'>
                                    <h4 className='text-grey fw-bold'>{product.name}</h4>
                                    <div>
                                        <Rating
                                            size='large'
                                            precision={0.5}
                                            value={product.ratings}
                                            readOnly
                                        />
                                        <span className='ps-2'>{product.numOfReviews} Reviews</span>
                                    </div>
                                    <h6>${product.price}</h6>
                                    <div className='qty'>
                                        <button
                                            className='incDecBtn'
                                            onClick={() => handleQuantity('DECREMENT')}
                                        >
                                            -
                                        </button>
                                        <input
                                            type='number'
                                            className='form-control'
                                            value={quantity}
                                            readOnly
                                        />
                                        <button
                                            className='incDecBtn'
                                            onClick={() => handleQuantity('INCREMENT')}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <button
                                        className='primary-btn'
                                        disabled={product.Stock <= 0 ? true : false}
                                        onClick={submitAddToCart}
                                    >
                                        Add to Cart
                                    </button>
                                    <hr />
                                    <div>
                                        Status:
                                        <b>{product.Stock > 0 ? 'In Stock' : 'Out of Stock'}</b>
                                    </div>
                                    <div className='mt-2'>
                                        Description: <b>{product.description}</b>
                                    </div>
                                    <button
                                        className='secondary-btn mt-3'
                                        onClick={handleToggleReviewModal}
                                    >
                                        Submit Review
                                    </button>
                                    <h5 className='text-grey mt-5 mb-3'>Reviews</h5>
                                    <Dialog
                                        open={openReviewModal}
                                        onClose={handleToggleReviewModal}
                                    >
                                        <DialogTitle>Submit Review</DialogTitle>
                                        <DialogContent>
                                            <Rating
                                                name='simple-controlled'
                                                size='large'
                                                precision={0.5}
                                                value={rating}
                                                onChange={(e, value) => setRating(value)}
                                            />
                                            <FloatingLabel
                                                controlId='floatingTextarea2'
                                                label='Comments'
                                            >
                                                <Form.Control
                                                    as='textarea'
                                                    placeholder='Leave a comment here'
                                                    style={{ height: '100px' }}
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                />
                                            </FloatingLabel>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button variant='success' onClick={handleSubmitRating}>
                                                Submit
                                            </Button>
                                            <Button
                                                variant='info'
                                                onClick={handleToggleReviewModal}
                                            >
                                                Cancel
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                    {product.numOfReviews > 0 ? (
                                        <div className='reviews'>
                                            {product.reviews.map((review, i) => (
                                                <ReviewCard key={i} review={review} />
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='noReviews'>
                                            No reviews yet <BsEmojiSmile />
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}
                </div>
            </Container>
        </>
    );
};

export default ProductDetails;
